<template>
  <mu-container class="center">
    <mu-form ref="form" @submit.prevent="handleSubmit" :model="loginData">
      <mu-form-item
        label="Adres email"
        help-text="Twój adres email"
        prop="email"
        :rules="emailRules"
      >
        <mu-text-field
          type="email"
          name="email"
          v-model="loginData.email"
          @keyup.enter.native="handleSubmit"
        >
        </mu-text-field>
      </mu-form-item>

      <mu-form-item
        label="Hasło"
        help-text="Twoje hasło"
        prop="password"
        :rules="passwordRules"
      >
        <mu-text-field
          type="password"
          name="password"
          v-model="loginData.password"
          @keyup.enter.native="handleSubmit"
        >
        </mu-text-field>
      </mu-form-item>

      <mu-form-item>
        <mu-button color="primary" @click="handleSubmit">Zaloguj!</mu-button>
      </mu-form-item>
    </mu-form>
  </mu-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "LoginPage",
  data() {
    return {
      emailRules: [
        { validate: val => !!val, message: "Email nie może być pusty!" },
        {
          validate: val => this.validEmail(val),
          message: "Podano niepoprawny email"
        }
      ],
      passwordRules: [
        { validate: val => !!val, message: "Hasło nie może być puste!" },
        {
          validate: val => val.length >= 3,
          message: "Hasło musi mieć przynajniej 3 znaki"
        }
      ],
      loginData: {
        email: "",
        password: ""
      },
      submitted: false
    };
  },
  computed: {
    ...mapState("user", ["status"])
  },
  methods: {
    ...mapActions("user", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$refs.form.validate().then(valid => {
        if (valid) {
          const { email, password } = this.loginData;
          this.login({ email, password });
        }
      });
    },
    validEmail(email) {
      //eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>

<style scoped>
.center {
  margin: 0 auto;
  max-width: 460px;
}
</style>
